'use client';

import { useEffect } from 'react';
import { ensureApiInitialized } from '@/lib/api';

/**
 * Client-side API initializer component
 * Ensures API is initialized on the client side
 */
export function ApiInitializer() {
  useEffect(() => {
    // Ensure API is initialized on client side
    ensureApiInitialized();
  }, []);

  // This component doesn't render anything
  return null;
}
